import React from 'react';
import $ from 'jquery';
import MenuLayout from './layout/MenuLayout';
import GuideSideBar from "./component/GuideSideBar";
import IntroContent from "./apis/IntroContent";
import TicketAPIContent from "./apis/TicketAPIContent/TicketAPIContent";
import GetAPIKeyContent from "./apis/GetAPIKeyContent";
import FAQsContent from "./apis/FAQsContent";
import TourAPIContent from "./apis/TourAPIContent/TourAPIContent";
import HMacSignatureContent from "./apis/HMacSignatureContent";
import Footer from './layout/Footer';
import MainBanner from './component/MainBanner'
import 'static/styles/apiguide.scss';
import 'static/styles/dashboard.scss';
import 'static/styles/monokai-sublime.scss';
import 'react-tabs/style/react-tabs.scss';
import CreateTourProduct from "./apis/TourAPIContent/V1/ProductAPI/CreateTourProduct";
import CreateTourProductItems from "./apis/TourAPIContent/V1/ProductAPI/CreateTourProductItems";
import DeleteTourProduct from "./apis/TourAPIContent/V1/ProductAPI/DeleteTourProduct";
import DeleteTourProductItem from "./apis/TourAPIContent/V1/ProductAPI/DeleteTourProductItem";
import UpdateTourInventoryByDate from "./apis/TourAPIContent/V1/ProductAPI/UpdateTourInventoryByDate";
import UpdateTourProduct from "./apis/TourAPIContent/V1/ProductAPI/UpdateTourProduct";
import UpdateTourProductItem from "./apis/TourAPIContent/V1/ProductAPI/UpdateTourProductItem";
import ViewSingleTourProduct from "./apis/TourAPIContent/V1/ProductAPI/ViewSingleTourProduct";
import ViewReservationList from "./apis/ReservationAndCancellation/ReservationAndRefundAPI/ViewReservationList";
import ViewSingleOrderReservation from "./apis/ReservationAndCancellation/ReservationAndRefundAPI/ViewSingleOrderReservation";
import ViewConfirmReservation from "./apis/ReservationAndCancellation/ReservationManagement/ViewConfirmReservation";
import ViewRejectReservation from "./apis/ReservationAndCancellation/ReservationManagement/ViewRejectReservation";
import ViewReservationManageHistory from "./apis/ReservationAndCancellation/ReservationManagementHistory/ViewManagementHistory";
import ViewApprovalCancellation from "./apis/ReservationAndCancellation/Cancellation/ViewApprovalCancellation";
import ViewTourProductHistory from "./apis/TourAPIContent/V1/ProductAPI/ViewTourProductHistory";
import ViewTourProductList from "./apis/TourAPIContent/V1/ProductAPI/ViewTourProductList";
import TicketUsageProcessing from "./apis/TicketAPIContent/TicketManagementAPI/TicketUsageProcessing";
import MutipleTicketUsageProcessing from "./apis/TicketAPIContent/TicketManagementAPI/MutipleTicketUsageProcessing";
import TicketFreeProcessing from "./apis/TicketAPIContent/TicketManagementAPI/TicketFreeProcessing";
import MutipleTicketUnusedProcessing from "./apis/TicketAPIContent/TicketManagementAPI/MutipleTicketUnusedProcessing";
import TicketBuyerInfoLookUp from "./apis/TicketAPIContent/TicketManagementAPI/TicketBuyerInfoLookup";
import ViewTicketDetails from "./apis/TicketAPIContent/TicketManagementAPI/ViewTicketDetails";
import ViewMutipleTicketDetails from "./apis/TicketAPIContent/TicketManagementAPI/ViewMutipleTicketDetails";
import TicketRefundRequest from "./apis/TicketAPIContent/TicketManagementAPI/TicketRefundRequest";
import TicketRefundRequestList from "./apis/TicketAPIContent/TicketManagementAPI/TicketRefundRequestList";
import ViewTicketBuyerInfoByV2API from "./apis/TicketAPIContent/TicketOrderInfoAPI/ViewTicketBuyerInfoByV2API";
import TravelTicketBuyerInfoByV1API from "./apis/TicketAPIContent/TicketOrderInfoAPI/TravelTicketBuyerInfoByV1API";
import ViewTicketBuyerInfoByOrderV2 from "./apis/TicketAPIContent/TicketOrderInfoAPI/ViewTicketBuyerInfoByOrderV2";
import ViewCanceledTicketInfoV2 from "./apis/TicketAPIContent/TicketOrderInfoAPI/ViewCanceledTicketInfoV2";
import CreateTicketProductItem from "./apis/TicketAPIContent/TicketProductAPI/CreateTicketProductItem";
import UpdateTicketProduct from "./apis/TicketAPIContent/TicketProductAPI/UpdateTicketProduct";
import UpdateTicketProductItem from "./apis/TicketAPIContent/TicketProductAPI/UpdateTicketProductItem";
import StartToSellTicketProduct from './apis/TicketAPIContent/TicketProductAPI/StartToSellTicketProduct';
import StopToSellTicketProduct from './apis/TicketAPIContent/TicketProductAPI/StopToSellTicketProduct';
import ViewSingleTicketProduct from "./apis/TicketAPIContent/TicketProductAPI/ViewSingleTicketProduct";
import ViewTicketProductByPage from "./apis/TicketAPIContent/TicketProductAPI/ViewTicketProductByPage";
import CreateTicketProduct from "./apis/TicketAPIContent/TicketProductAPI/CreateTicketProduct";
import DeleteTicketProduct from "./apis/TicketAPIContent/TicketProductAPI/DeleteTicketProduct";
import DeleteTicketProductItem from "./apis/TicketAPIContent/TicketProductAPI/DeleteTicketProductItem";
import ViewTourItemInventories from "./apis/TourAPIContent/V1/ProductAPI/ViewTourItemInventories";
import ViewTicketItemInventories from "./apis/TicketAPIContent/TicketProductAPI/ViewTicketItemInventories";
import UpdateTicketInventoryByDate from "./apis/TicketAPIContent/TicketProductAPI/UpdateTicketInventoryByDate";
import CreateTourProductV2 from './apis/TourAPIContent/V2/ProductAPI/CreateTourProductV2';
import UpdateTourProductV2 from './apis/TourAPIContent/V2/ProductAPI/UpdateTourProductV2';
import UpdateTourInventoryByDateV2 from './apis/TourAPIContent/V2/ProductAPI/UpdateTourInventoryByDateV2';
import ViewTourItemInventoriesV2 from './apis/TourAPIContent/V2/ProductAPI/ViewTourItemInventoriesV2';
import ReservationAndCancellationAPIContent
    from './apis/ReservationAndCancellation/ReservationAndCancellationAPIContent';
import LodgingAPIContent from './apis/LodgingAPIContent/LodgingAPIContent';
import CreateLodgingProducts from './apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProducts';
import CreateLodgingProductRooms from './apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProductRooms';
import CreateLodgingProductRatePlans from './apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProductRatePlans';
import DeleteLodgingProduct from './apis/LodgingAPIContent/LodgingProductAPI/DeleteLodgingProduct';
import DeleteLodgingRatePlan from './apis/LodgingAPIContent/LodgingProductAPI/DeleteLodgingRatePlan';
import GetLodgingProductInfo from './apis/LodgingAPIContent/LodgingProductAPI/GetLodgingProductInfo';
import UpdateLodgingProducts from './apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingProducts';
import UpdateLodgingProductRatePlan from './apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingProductRatePlan';
import UpdateLodgingProductRoom from './apis/LodgingAPIContent/LodgingProductAPI/UpdateLodingProductRoom';
import UpdateLodgingInventory from './apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingInventory';


export default class GuideEntryContainer extends React.Component {

    static pathToHTML = require.context('static/content', true);
    static HTML_PREFIX = "./";

    constructor(props) {
        super(props);
        let active = MenuLayout.ACTIVE_DEFAULT;
        this.state = {
            activeName: active.name,
            contentPage: active.contentPage,
            mainBannerText: "",
            newDiv:<IntroContent/>,
            elementNameValue:"guides-section-01",
            sidebar: {
                $menu: [],
                $pageHeader: []
            },
            divDic : {
                "guides-section-01":<IntroContent/>,
                "guides-section-02":<HMacSignatureContent/>,
                "guides-section-03": <GetAPIKeyContent/>,
                "guides-section-07": <FAQsContent/>,
                // "guides-section-06": <ReservationAndCancellationAPIContent/>,

                "ticket-usage-processing":<TicketAPIContent newDiv = {<TicketUsageProcessing/>}/>,
                "mutiple-ticket-usage-processing":<TicketAPIContent newDiv = {<MutipleTicketUsageProcessing/>}/>,
                "ticket-free-processing":<TicketAPIContent newDiv = {<TicketFreeProcessing/>}/>,
                "mutiple-ticket-unused-processing":<TicketAPIContent newDiv = {<MutipleTicketUnusedProcessing/>}/>,
                "ticket-buyer-info-lookup":<TicketAPIContent newDiv = {<TicketBuyerInfoLookUp/>}/>,
                "view-ticket-details":<TicketAPIContent newDiv = {<ViewTicketDetails/>}/>,
                "view-mutiple-ticket-details":<TicketAPIContent newDiv = {<ViewMutipleTicketDetails/>}/>,
                "ticket-refund-request":<TicketAPIContent newDiv = {<TicketRefundRequest/>}/>,
                "ticket-refund-request-list":<TicketAPIContent newDiv = {<TicketRefundRequestList/>}/>,
                "view-ticket-buyer-info-V2API":<TicketAPIContent newDiv = {<ViewTicketBuyerInfoByV2API/>}/>,
                "travel-ticket-buyer-info-V1API":<TicketAPIContent newDiv = {<TravelTicketBuyerInfoByV1API/>}/>,
                "view-ticket-buyer-info-by-order-V2":<TicketAPIContent newDiv = {<ViewTicketBuyerInfoByOrderV2/>}/>,
                "view-canceled-ticket-info-V2":<TicketAPIContent newDiv = {<ViewCanceledTicketInfoV2/>}/>,
                "create-tour-product":<TourAPIContent newDiv = {<CreateTourProduct/>}/>,
                "create-tour-product-items":<TourAPIContent newDiv={<CreateTourProductItems/>}/>,
                "delete-tour-product":<TourAPIContent newDiv = {<DeleteTourProduct/>}/>,
                "delete-tour-product-item":<TourAPIContent newDiv = {<DeleteTourProductItem/>}/>,
                "update-tour-inventory-by-date":<TourAPIContent newDiv = {<UpdateTourInventoryByDate/>}/>,
                "view-tour-item-inventories":<TourAPIContent newDiv = {<ViewTourItemInventories/>}/>,
                "update-tour-product":<TourAPIContent newDiv = {<UpdateTourProduct/>}/>,
                "update-tour-product-item":<TourAPIContent newDiv = {<UpdateTourProductItem/>}/>,

                "view-tour-product-history":<TourAPIContent newDiv = {<ViewTourProductHistory/>}/>,
                "view-tour-product-list":<TourAPIContent newDiv = {<ViewTourProductList/>}/>,
                "create-ticket-product":<TicketAPIContent newDiv = {<CreateTicketProduct/>}/>,
                "create-ticket-product-item":<TicketAPIContent newDiv = {<CreateTicketProductItem/>}/>,
                "delete-ticket-product":<TicketAPIContent newDiv = {<DeleteTicketProduct/>}/>,
                "delete-ticket-product-item":<TicketAPIContent newDiv = {<DeleteTicketProductItem/>}/>,
                "update-ticket-product":<TicketAPIContent newDiv = {<UpdateTicketProduct/>}/>,
                "update-ticket-product-item":<TicketAPIContent newDiv = {<UpdateTicketProductItem/>}/>,
                "start-to-sell-ticket-product":<TicketAPIContent newDiv={<StartToSellTicketProduct/>}/>,
                "stop-to-sell-ticket-product":<TicketAPIContent newDiv={<StopToSellTicketProduct/>}/>,
                "view-single-ticket-product":<TicketAPIContent newDiv = {<ViewSingleTicketProduct/>}/>,
                "view-ticket-product-by-page":<TicketAPIContent newDiv = {<ViewTicketProductByPage/>}/>,
                "update-ticket-inventory-by-date":<TicketAPIContent newDiv={<UpdateTicketInventoryByDate/>}/>,
                "view-ticket-item-inventories":<TicketAPIContent newDiv={<ViewTicketItemInventories/>}/>,
                "create-tour-product-V2API":<TourAPIContent newDiv={<CreateTourProductV2/>}/>,
                "update-tour-product-V2API":<TourAPIContent newDiv={<UpdateTourProductV2/>}/>,
                "update-tour-inventory-by-date-V2API":<TourAPIContent newDiv={<UpdateTourInventoryByDateV2/>}/>,
                "view-tour-inventories-V2API":<TourAPIContent newDiv={<ViewTourItemInventoriesV2/>}/>,

                "view-reservation-list":<ReservationAndCancellationAPIContent newDiv = {<ViewReservationList/>}/>,
                "view-single-tour-product":<ReservationAndCancellationAPIContent newDiv = {<ViewSingleTourProduct/>}/>,
                "view-single-order-reservation":<ReservationAndCancellationAPIContent newDiv = {<ViewSingleOrderReservation/>}/>,

                "view-confirm-reservation":<ReservationAndCancellationAPIContent newDiv = {<ViewConfirmReservation/>}/>,
                "view-reject-reservation":<ReservationAndCancellationAPIContent newDiv = {<ViewRejectReservation/>}/>,
                "view-reservation-manage-history":<ReservationAndCancellationAPIContent newDiv = {<ViewReservationManageHistory/>}/>,
                "view-approval-cancellation":<ReservationAndCancellationAPIContent newDiv = {<ViewApprovalCancellation/>}/>,

                "create-lodging-products":<LodgingAPIContent newDiv = {<CreateLodgingProducts/>}/>,
                "create-lodging-product-rooms":<LodgingAPIContent newDiv = {<CreateLodgingProductRooms/>}/>,
                "create-lodging-product-rate-plans":<LodgingAPIContent newDiv = {<CreateLodgingProductRatePlans/>}/>,
                "delete-lodging-product":<LodgingAPIContent newDiv = {<DeleteLodgingProduct/>}/>,
                "delete-lodging-rate-plan":<LodgingAPIContent newDiv = {<DeleteLodgingRatePlan/>}/>,
                "get-lodging-product-info":<LodgingAPIContent newDiv = {<GetLodgingProductInfo/>}/>,
                "update-lodging-product-products":<LodgingAPIContent newDiv = {<UpdateLodgingProducts/>}/>,
                "update-lodging-product-rate-plan":<LodgingAPIContent newDiv = {<UpdateLodgingProductRatePlan/>}/>,
                "update-lodging-product-room":<LodgingAPIContent newDiv = {<UpdateLodgingProductRoom/>}/>,
                "update-lodging-inventory":<LodgingAPIContent newDiv = {<UpdateLodgingInventory/>}/>

            }
        };
        this.standardTop = 492;
        this.divList = Object.keys(this.state.divDic);
        // this.handleHashChange();
    };


    getActive(hashValue) {
        let activeKey = (hashValue.indexOf("guides-") == 0) ? "guides" : hashValue;
        return MenuLayout.ACTIVES[activeKey] || MenuLayout.ACTIVE_DEFAULT;
    }

    getMenuElement() {
        if (!this.state.sidebar.$menu || this.state.sidebar.$menu.length <= 0) {
            this.state.sidebar.$menu = $('.nav-sidebar li.m')
        }
        return this.state.sidebar.$menu;
    }

    getPageHeaderElement() {
        if (!this.state.sidebar.$pageHeader || this.state.sidebar.$pageHeader.length <= 0) {
            this.state.sidebar.$pageHeader = $('.page-header');
        }
        return this.state.sidebar.$pageHeader;
    }

    getElementNameValue(event){
        console.log(event.target.name);
        this.setState({elementNameValue:event.target.name},() =>{
            console.log(this.state.elementNameValue);//setState是异步操作，但是我们可以在它的回调函数里面进行操作
            // console.log(this.state.oldDiv);
            if(this.divList.includes(this.state.elementNameValue)){
                $("body,html").animate({scrollTop:442},1000);
            }
        });
    }

    componentDidMount() {

        let self = this;

        $('.sidebar').addClass("f-nav").css("top", self.standardTop);

        // menu class 추가
        $(window).scroll(function () {
            let $menu = self.getMenuElement(),
                $contents = self.getPageHeaderElement();

            //console.log("scroll");

            let scltop = $(window).scrollTop();
            let newScrollTop = self.standardTop - $(window).scrollTop();
            $('.sidebar').addClass("f-nav").css("top", Math.max(newScrollTop, 70));
        //     $.each($contents, function (idx, item) {
        //         let $target = $contents.eq(idx),
        //             i = $target.index(),
        //             targetTop = $target.offset().top - $('.container-fluid').height() - 40;
        //
        //         if (targetTop <= scltop) {
        //             $menu.removeClass('active');
        //             $menu.eq(idx).addClass('active');
        //         }
        //         if (!(70 <= scltop)) {
        //             $menu.removeClass('active');
        //         }
        //     })
        });
    }

    handleChangeMainBannerText(text) {
        this.setState((old) => {
            old.mainBannerText = text
        })
    }

    // handleHashChange() {
    //     let self = this;
    //     $(window).on('hashchange', function () {
    //         let hashValue = location.hash.slice(1) || "";
    //
    //         console.log(">>>>>>>>>>> hashValue", hashValue);
    //
    //         if (false == (hashValue.indexOf("guides") == 0)) {
    //             self.setState(function (old) {
    //                 old.sidebar = {};
    //                 return old;
    //             });
    //         }
    //
    //         /***************************************************/
    //
    //         if (hashValue.indexOf("guides") == 0) {
    //             let active = self.getActive("guides");
    //             //console.log(">>>> active", active);
    //             if (active && active.name) {
    //                 self.handleMenuClick(active.name, active.contentPage.split(".")[1]);
    //             }
    //             return;
    //         }
    //
    //         let active = self.getActive(hashValue);
    //         if (active && active.name) {
    //             self.handleMenuClick(active.name, active.contentPage.split(".")[1]);
    //         }
    //     });
    // }

    handleMenuClick(activeName, type, func) {
        type = type || "html";
        this.setState(function (old) {
            old.activeName = activeName;
            old.contentPage = activeName + "." + type;
            return old;
        }, func || function () {
        });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        let keys = Object.keys(this.state.divDic);
        return keys.includes(nextState.elementNameValue);
    }

    // shouldComponentUpdate(nextProps,nextState) {
    //     let keys = Object.keys(this.state.divDic);
    //
    //     // !Object.keys(nextState.state.divDic).includes(nextState.elementNameValue);
    // }

    getRenderConponent(elementNameValue){
        let renderDiv=null;
        let divKeys = Object.keys(this.state.divDic);
        if(divKeys.includes(this.state.elementNameValue)){
            return this.rederDiv = this.state.divDic[this.state.elementNameValue];
            // this.oldDivChange(div);
        }
        return renderDiv;
    }

    renderHTML(fileName) {
        return (
            <div dangerouslySetInnerHTML={{__html: GuideEntryContainer.pathToHTML(fileName, true)}}></div>
        );
    }

    renderContent() {
        // const
        return (
            <div className="row">
                <div className="col-sm-3 col-md-2 sidebar f-nav" style={{top: 492}}>
                    <GuideSideBar getElementNameValue={this.getElementNameValue.bind(this)}/>
                </div>
                <div className="col-sm-9 col-sm-offset-3 col-md-10 main" style={{top: -60}}>
                    {/*<div id={"clone"}>*/}
                    {this.getRenderConponent(this.state.elementNameValue)}
                    {/*</div>*/}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="red">
                <MenuLayout activeName={this.state.activeName} onMenuClick={this.handleMenuClick.bind(this)}/>
                <MainBanner onChange={this.handleChangeMainBannerText.bind(this)} text={this.state.mainBannerText}/>
                <div className="container-fluid">
                    {this.renderContent()}
                    <hr/>
                    <Footer/>
                </div>
            </div>
        );
    }

}

ReactDOM.render(<GuideEntryContainer/>, document.getElementById('main-wrapper'));


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/GuideEntryContainer.jsx